import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useParams, useNavigate } from "react-router-dom";
import "./styles.scss";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../actions/actions";

const TabManagerGeneric = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { tabId, tabId2 = '' } = useParams();
  const [tabs, setTabs] = useState(props.tabsData);
  const changeActiveTab = (e, tabId) => {
    e.preventDefault();
    navigate('/' + props.mainPathName + "/" + tabId);
  };

  useEffect(() => {
    setTabs((prevState) =>
      prevState.map((tab) => {
        const updatedTab = { ...tab };
        updatedTab.isActive = tab.tabId === tabId
        return updatedTab;
      })
    );
  }, [tabId, tabId2]);

  const Component = tabs?.find((tab) => tab.isActive === true)?.component;
  const TitleActive = tabs?.find((tab) => tab.isActive === true);
  dispatch(setActiveTab(TitleActive?.tabTitle));

  return (
    <div className="tab-manager">
      <div className="tab-headers">
        {tabs.map((tab) => (
          <button
            type="button"
            className={`tab-header ${tab.isActive && "active-tab"}`}
            onClick={(e) => {
              changeActiveTab(e, tab.tabId);
            }}
            key={tab.tabTitle}
          >
            <div>{tab.tabTitle}</div>
            <Box
              bgcolor="primary.main"
              className={`${tab.isActive && "active-tab-indicator"}`}
            />
          </button>
        ))}
      </div>
      <div className="tab-content">
        {Component && <Component />}
      </div>
    </div>
  );
};

TabManagerGeneric.propTypes = {
  tabsData: PropTypes.arrayOf(
    PropTypes.shape({
      tabTitle: PropTypes.string,
      tabId: PropTypes.string,
      isActive: PropTypes.bool,
      component: PropTypes.elementType,
    })
  ),
  mainPathName: PropTypes.string,
};

export default TabManagerGeneric;
